import React from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import DateTimePicker from 'common/components/form/DateTimePicker'
import Input from 'common/components/form/Input'
import PropTypes from 'prop-types'
import Select from 'common/components/form/Select'
import { COMMERCIAL_SENSITIVITY, CUSTOMER_STATUS, VIGILANCE } from 'dashboard/utils/DashboardUtils'
import { Circle } from '@mui/icons-material'
import Checkbox from 'common/components/form/Checkbox'

const CustomerCard = ({
    customer = {},
    readMode,
    onChange = () => {},
}) => (
    <Card>
        <CardContent>
            <Grid container spacing={1} alignItems='flex-start'>
                <Grid size={6} container>
                    <Grid size={8}>
                        <Input
                            label='Nom'
                            value={customer.name}
                            onChange={(v) => onChange({ ...customer, name: v })}
                            disabled={readMode}
                            required
                        />
                    </Grid>
                    <Grid size={4}>
                        <Input
                            label='Mnémonique'
                            value={customer.mnemonic}
                            onChange={(v) => onChange({ ...customer, mnemonic: v })}
                            disabled={readMode}
                        />
                    </Grid>
                    <Grid size={12}>
                        <Input
                            label='Description'
                            value={customer.description}
                            onChange={(v) => onChange({ ...customer, description: v })}
                            multiline
                            disabled={readMode}
                        />
                    </Grid>
                </Grid>
                <Grid size={6} container>
                    <Grid size={6}>
                        <Select
                            label='Statut'
                            items={CUSTOMER_STATUS}
                            value={customer.status}
                            onChange={(v) => onChange({ ...customer, status: v })}
                            sortItems={false}
                            undefinedValue
                            disabled={readMode}
                        />
                    </Grid>
                    <Grid size={3}>
                        <DateTimePicker
                            label='Date de début'
                            value={customer.startDate}
                            onChange={(v) => onChange({ ...customer, startDate: v })}
                            disabled={readMode}
                            required
                        />
                    </Grid>
                    <Grid size={3}>
                        <DateTimePicker
                            label='Date de fin'
                            value={customer.endDate}
                            onChange={(v) => onChange({ ...customer, endDate: v })}
                            disabled={readMode}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label='Vigilance'
                            items={[{
                                value: VIGILANCE.HIGH,
                                label: <Grid container spacing={1} alignItems='center'><Circle sx={{ color: 'red', fontSize: '1rem' }} />Forte</Grid>,
                            }, {
                                value: VIGILANCE.MEDIUM,
                                label: <Grid container spacing={1} alignItems='center'><Circle sx={{ color: 'orange', fontSize: '1rem' }} />Moyenne</Grid>,
                            },
                            {
                                label: 'Aucune',
                                value: undefined,
                            }]}
                            value={customer.vigilance}
                            onChange={(v) => onChange({ ...customer, vigilance: v })}
                            disabled={readMode}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label='Sensibilité commerciale'
                            items={COMMERCIAL_SENSITIVITY.map((s) => ({
                                value: s.value,
                                label: <Grid container spacing={1} alignItems='center'><Circle sx={{ color: s.color, fontSize: '1rem' }} />{s.label}</Grid>,
                            }))}
                            value={customer.commercialSensitivity}
                            onChange={(v) => onChange({ ...customer, commercialSensitivity: v })}
                            sortItems={false}
                            undefinedValue
                            disabled={readMode}
                        />
                    </Grid>
                    <Grid size={6}>
                        <DateTimePicker
                            label='Prochaine échéance'
                            value={customer.nextDeadline}
                            onChange={(v) => onChange({ ...customer, nextDeadline: v })}
                            disabled={readMode}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Checkbox
                            label='Licence activée'
                            checked={customer.licenceActive}
                            onChange={() => onChange({ ...customer, licenceActive: !customer.licenceActive })}
                            disabled={readMode}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </CardContent>
    </Card>
)

export default CustomerCard

CustomerCard.propTypes = {
    customer: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        mnemonic: PropTypes.string,
        description: PropTypes.string,
        startDate: PropTypes.instanceOf(Date),
        endDate: PropTypes.instanceOf(Date),
        licenceActive: PropTypes.bool,
        vigilance: PropTypes.string,
        status: PropTypes.number,
        commercialSensitivity: PropTypes.number,
        nextDeadline: PropTypes.instanceOf(Date),
    }).isRequired,
    readMode: PropTypes.bool,
    onChange: PropTypes.func,
}